import {
    useDispatch,
    useSelector,
    useStore,
    type RootState,
    type AppDispatch,
    type TypedUseSelectorHook,
    type Store
} from "infrastructure/store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppStore: () => Store<RootState> = useStore;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
